import router from './router';
import socket from './socket';
import login from './login';
import modal from './modal';
import user from './user';
import factory from './factory';
import factoryMembership from './factory-membership';
import site from './site';
import label from './label';
import line from './line';
import device from './device';
import alarm from './alarm';
import attachment from './attachment';
import actions from './actions';
import commentAction from './comment-action';
import notification from './notification';
import model from './model';
import protocol from './protocol';
import channel from './channel';
import item from './item';
import alertSetting from './alert-setting';
import alerts from './alerts';
import reports from './reports';
import dashboard from './dashboard';
import invoices from './invoices';
import settingPrice from './setting-price';
import diagram from './diagram';
import system from './system';
import architecture from './architecture';
import settingEmails from './setting-emails';

export default [
  router,
  socket,
  login,
  modal,
  user,
  factory,
  factoryMembership,
  site,
  label,
  line,
  device,
  alarm,
  attachment,
  actions,
  commentAction,
  notification,
  model,
  protocol,
  channel,
  item,
  alertSetting,
  alerts,
  reports,
  dashboard,
  invoices,
  settingPrice,
  diagram,
  system,
  architecture,
  settingEmails,
];
